import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d4d804f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_line1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "_line_wrap",
    style: _normalizeStyle({
            top:`${-100}px`,
            height: `${_ctx.rendered ? _ctx.getLineHeight() : 0}px`
        })
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "_line2",
      style: _normalizeStyle({height:`${_ctx.getLineHeight() * _ctx.getHeightPercents()}px`})
    }, null, 4)
  ], 4))
}